import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.aniervincent.fr/api',
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const login = (email, password) =>
    api.post('/auth/login', { email, password });

export const getPatients = () =>
    api.get('/patients');

export const getDeliveries = (dateDebut, dateFin) =>
    api.get(`/deliveries?date[after]=${dateDebut}&date[before]=${dateFin}`);

export const updateDeliveryPosition = (id, data) =>
    api.patch(`/deliveries/${id}`, data, {
        headers: { 'Content-Type': 'application/merge-patch+json' }
    });

export default api;